// Typelizer digest 62f12c4bda40e36ce9e30c9700c9cea2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /plantings/:id/export */
  export: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/plantings/:id/export', params, options),
    method: 'get',
  }),

  /** POST /plantings */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/plantings', {}, options),
    method: 'post',
  }),

  /** PATCH /plantings/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/plantings/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /plantings/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/plantings/:id', params, options),
    method: 'delete',
  }),
}
